import { z } from "zod";
import { useTranslation } from "react-i18next";

// Read at a boundary, not trusted from the type: after a rollback an older
// API sends neither field, and the page must then show no notes rather than
// crash.
const complianceTexts = z.object({
  legalNotice: z.string().nullable(),
  interestDisclosure: z.string().nullable(),
});

/**
 * The client's compliance texts of a playlist, under its items: the links of
 * interest of an expert playlist, then the legal mentions or the regulatory
 * code. CX pastes the text that the client validated, so it shows as is.
 */
export function PlaylistComplianceNotes({
  playlist,
  className,
}: {
  playlist: { legalNotice: string | null; interestDisclosure: string | null };
  className: string | null;
}) {
  const { t } = useTranslation();
  const parsed = complianceTexts.safeParse(playlist);
  if (!parsed.success) return null;
  const { legalNotice, interestDisclosure } = parsed.data;
  if (legalNotice === null && interestDisclosure === null) return null;
  return (
    <div
      className={`flex flex-col gap-3 text-footnote text-ds-slate-600 ${className === null ? "" : className}`}
    >
      {interestDisclosure === null ? null : (
        <div className="flex flex-col gap-1">
          <p className="m-0 font-semibold">{t("Declarations of interest")}</p>
          <p className="m-0 whitespace-pre-line">{interestDisclosure}</p>
        </div>
      )}
      {legalNotice === null ? null : (
        <p className="m-0 whitespace-pre-line">{legalNotice}</p>
      )}
    </div>
  );
}
